import type { HTMLAttributes } from 'react';

export type PageFrameProps = HTMLAttributes<HTMLElement>;

export function PageFrame({ className, ...frameProps }: PageFrameProps) {
  const classes = ['page-area', 'ihd-page-frame', className ?? ''].filter(Boolean).join(' ');
  return <main {...frameProps} className={classes} />;
}
